import "./instrument"
import React from "react"
import { createRoot } from "react-dom/client"

import { create } from "zustand"

import "./index.css"
import App from "./App"
import * as serviceWorkerRegistration from "./serviceWorkerRegistration"

// import reportWebVitals from './reportWebVitals';

export const useSWStore = create((set) => ({
  swInitialized: false,
  swUpdated: false,
  swRegistration: null,
}))

const root = createRoot(document.getElementById("root"))
root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
)

serviceWorkerRegistration.register({
  onSuccess: reg => useSWStore.setState({ swInitialized: true, swRegistration: reg }),
  onUpdate: reg => useSWStore.setState({ swUpdated: true, swRegistration: reg }),
})
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
